import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { ISRResponse } from '_core/types';
import { ResetPasswordTypes } from '../Types';

const machine = Machines.onResetPassword.machine;

export const resetPassword = (
  params: ResetPasswordTypes.ResetPasswordServiceRequestType,
): Promise<ISRResponse> => {
  return callServiceMachine(machine, params);
};

export default { resetPassword };
